// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin Data Pipeline (창업컨설팅 에이전트 데이터 관리) ===== */

.admin-dp__tabs {
  margin-bottom: 20px;
  width: fit-content;
}

/* ── 에이전트 선택기 (헤더) ── */
.admin-dp__agent-picker {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: var(--admin-accent-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
  color: var(--admin-accent);
  transition: border-color 0.15s;
}

.admin-dp__agent-picker:focus-within {
  border-color: var(--admin-accent);
}

.admin-dp__agent-select {
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
  cursor: pointer;
  outline: none;
  padding-right: 4px;
  font-family: inherit;
}

/* ── 공통 ── */
.admin-dp__mono {
  font-family: var(--admin-font-mono);
  font-size: 12px;
}

.admin-dp__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: adminDpSpin 0.7s linear infinite;
}

.admin-btn--secondary .admin-dp__spinner {
  border-color: var(--admin-border);
  border-top-color: var(--admin-text-secondary);
}

@keyframes adminDpSpin {
  to { transform: rotate(360deg); }
}

/* ── 섹션 로딩/에러/빈 상태 ── */
.admin-dp__state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 220px;
  padding: 40px 20px;
  color: var(--admin-text-muted);
  font-size: 13px;
}

.admin-dp__state--error {
  flex-direction: column;
  color: var(--admin-text-secondary);
}

.admin-dp__state-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid var(--admin-border);
  border-top-color: var(--admin-accent);
  border-radius: 50%;
  animation: adminDpSpin 0.7s linear infinite;
}

.admin-pg__ellipsis {
  padding: 0 4px;
  color: var(--admin-text-muted);
  font-size: 13px;
}

.admin-dp__source-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  white-space: nowrap;
}

.admin-dp__source-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.admin-dp__count {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-dp__count--new {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-dp__count--upd {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-dp__count--exp {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-dp__count--skip {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

/* ── 탭 1: 개요 ── */
.admin-dp__overview {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.admin-dp__kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.admin-dp__kpi {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
}

.admin-dp__kpi-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--admin-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.admin-dp__kpi-icon--accent {
  background: var(--admin-accent-bg);
  color: var(--admin-accent);
}

.admin-dp__kpi-icon--info {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-dp__kpi-icon--success {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-dp__kpi-icon--error {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-dp__kpi-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.admin-dp__kpi-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-muted);
}

.admin-dp__kpi-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--admin-text-bright);
  line-height: 1.2;
}

.admin-dp__kpi-sub {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-dp__overview-row {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
}

.admin-dp__chart-legend {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-dp__source-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 20px;
}

.admin-dp__source-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--admin-border-light);
}

.admin-dp__source-row:last-child {
  border-bottom: none;
}

.admin-dp__source-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.admin-dp__source-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-dp__source-time {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-family: var(--admin-font-mono);
}

.admin-dp__source-counts {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-dp__trend-chart {
  width: 100%;
  max-width: 360px;
  display: block;
  margin: 0 auto;
}

.admin-dp__trend-bar {
  fill: var(--admin-accent);
  opacity: 0.85;
}

.admin-dp__trend-value {
  font-size: 10px;
  font-weight: 600;
  fill: var(--admin-text-secondary);
}

.admin-dp__trend-date {
  font-size: 10px;
  fill: var(--admin-text-muted);
}

/* 파이프라인 흐름 */
.admin-dp__flow {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.admin-dp__flow-step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px 12px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
  text-align: center;
}

.admin-dp__flow-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-secondary);
}

.admin-dp__flow-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

.admin-dp__flow-sub {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-dp__flow-branch {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}

.admin-dp__flow-arrow {
  display: flex;
  align-items: center;
  color: var(--admin-text-dim);
  flex-shrink: 0;
}

/* ── 탭 2: 데이터 검수 ── */
.admin-dp__review {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.admin-dp__filter-card .admin-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
}

.admin-dp__filter-cats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.admin-dp__cat-chip {
  padding: 5px 12px;
  border: 1px solid var(--admin-border);
  border-radius: 9999px;
  background: var(--admin-surface);
  color: var(--admin-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-dp__cat-chip:hover {
  border-color: var(--admin-accent);
  color: var(--admin-accent);
}

.admin-dp__cat-chip--on {
  background: var(--admin-accent-bg);
  border-color: var(--admin-accent);
  color: var(--admin-accent);
  font-weight: 600;
}

.admin-dp__filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-dp__filter-select {
  width: auto;
  min-width: 120px;
  padding: 8px 12px;
  font-size: 12px;
}

.admin-dp__filter-search {
  flex: 1 1;
  max-width: 280px;
  margin-left: auto;
}

.admin-dp__title-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 220px;
}

.admin-dp__title-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-dp__title-sub {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-family: var(--admin-font-mono);
}

.admin-dp__cat-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 200px;
}

.admin-dp__cat-tag {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 9999px;
  background: var(--admin-accent-bg);
  color: var(--admin-accent-hover);
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-dp__amount {
  font-weight: 600;
  color: var(--admin-text-primary);
  white-space: nowrap;
}

.admin-dp__deadline-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.admin-dp__dday {
  font-size: 11px;
  font-weight: 700;
  color: var(--admin-text-muted);
}

.admin-dp__dday--urgent {
  color: var(--admin-error);
}

.admin-dp__empty-row td {
  text-align: center;
  padding: 48px 16px;
  color: var(--admin-text-muted);
  font-size: 13px;
  cursor: default;
}

.admin-dp__empty-row:hover {
  background: transparent !important;
}

/* ── 탭 3: 동기화 이력 ── */
.admin-dp__history-table td {
  white-space: nowrap;
}

.admin-dp__num--new {
  color: var(--admin-success);
  font-weight: 600;
}

.admin-dp__num--upd {
  color: var(--admin-info);
  font-weight: 600;
}

.admin-dp__run-row--failed {
  background: var(--admin-error-bg);
}

.admin-dp__run-log-row td {
  background: var(--admin-bg);
  cursor: default;
}

.admin-dp__run-log {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 4px 8px;
}

.admin-dp__run-log-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--admin-error);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  flex-shrink: 0;
}

.admin-dp__run-log code {
  font-family: var(--admin-font-mono);
  font-size: 12px;
  color: var(--admin-text-secondary);
  white-space: pre-wrap;
  word-break: break-all;
}

/* ── 탭 4: 분류체계 ── */
.admin-dp__taxonomy {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.admin-dp__cat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.admin-dp__cat-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
}

.admin-dp__cat-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.admin-dp__cat-card-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--admin-text-primary);
}

.admin-dp__cat-card-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-accent);
  background: var(--admin-accent-bg);
  padding: 2px 8px;
  border-radius: 9999px;
}

.admin-dp__cat-card-desc {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-dp__mapping-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.admin-dp__mapping-add {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--admin-bg);
  border: 1px dashed var(--admin-border);
  border-radius: var(--admin-radius-md);
}

.admin-dp__mapping-input {
  flex: 1 1;
  padding: 8px 12px;
  font-size: 12px;
}

.admin-dp__mapping-arrow {
  color: var(--admin-text-muted);
  flex-shrink: 0;
}

.admin-dp__mapping-row {
  cursor: default !important;
}

.admin-dp__mapping-actions {
  text-align: right;
}

/* ── 상세 드로어 ── */
.admin-dp__drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(2px);
  z-index: 900;
  animation: adminDpFadeIn 0.15s ease;
}

@keyframes adminDpFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.admin-dp__drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 760px;
  max-width: 92vw;
  background: var(--admin-surface);
  border-left: 1px solid var(--admin-border);
  box-shadow: var(--admin-shadow-modal);
  z-index: 901;
  display: flex;
  flex-direction: column;
  animation: adminDpSlideIn 0.2s ease;
}

@keyframes adminDpSlideIn {
  from { transform: translateX(24px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

.admin-dp__drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-dp__drawer-titles {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.admin-dp__drawer-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--admin-text-bright);
  margin: 0;
  line-height: 1.4;
}

.admin-dp__drawer-badges {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-dp__drawer-sourceid {
  color: var(--admin-text-muted);
}

.admin-dp__drawer-body {
  flex: 1 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.admin-dp__drawer-col {
  padding: 20px 24px;
  min-width: 0;
}

.admin-dp__drawer-col:first-child {
  border-right: 1px solid var(--admin-border);
  background: var(--admin-bg);
}

.admin-dp__drawer-col-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: var(--admin-text-primary);
  margin: 0 0 14px;
}

.admin-dp__drawer-col-hint {
  font-size: 11px;
  font-weight: 400;
  color: var(--admin-text-muted);
}

.admin-dp__raw-json {
  margin: 0;
  padding: 14px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
  font-family: var(--admin-font-mono);
  font-size: 11.5px;
  line-height: 1.7;
  color: var(--admin-text-secondary);
  white-space: pre-wrap;
  word-break: break-all;
}

.admin-dp__norm-list {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.admin-dp__norm-row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid var(--admin-border-light);
}

.admin-dp__norm-row:last-child {
  border-bottom: none;
}

.admin-dp__norm-row dt {
  font-family: var(--admin-font-mono);
  font-size: 11.5px;
  color: var(--admin-text-muted);
}

.admin-dp__norm-row dd {
  margin: 0;
  font-size: 13px;
  color: var(--admin-text-primary);
  word-break: break-word;
}

.admin-dp__edit-form .admin-form-group {
  margin-bottom: 14px;
}

.admin-dp__edit-textarea {
  resize: vertical;
  font-family: inherit;
}

.admin-dp__drawer-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 24px;
  border-top: 1px solid var(--admin-border);
}

.admin-dp__drawer-footer-left,
.admin-dp__drawer-footer-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── 반응형 ── */
@media (max-width: 1280px) {
  .admin-dp__kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .admin-dp__overview-row {
    grid-template-columns: 1fr;
  }

  .admin-dp__cat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 960px) {
  .admin-dp__flow {
    flex-direction: column;
  }

  .admin-dp__flow-arrow {
    transform: rotate(90deg);
    justify-content: center;
  }

  .admin-dp__drawer-body {
    grid-template-columns: 1fr;
  }

  .admin-dp__drawer-col:first-child {
    border-right: none;
    border-bottom: 1px solid var(--admin-border);
  }

  .admin-dp__filter-row {
    flex-wrap: wrap;
  }

  .admin-dp__filter-search {
    max-width: none;
    width: 100%;
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminDataPipeline.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,0CAA0C;EAC1C,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc;AACd;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":["/* ===== Admin Data Pipeline (창업컨설팅 에이전트 데이터 관리) ===== */\n\n.admin-dp__tabs {\n  margin-bottom: 20px;\n  width: fit-content;\n}\n\n/* ── 에이전트 선택기 (헤더) ── */\n.admin-dp__agent-picker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  background: var(--admin-accent-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n  color: var(--admin-accent);\n  transition: border-color 0.15s;\n}\n\n.admin-dp__agent-picker:focus-within {\n  border-color: var(--admin-accent);\n}\n\n.admin-dp__agent-select {\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  cursor: pointer;\n  outline: none;\n  padding-right: 4px;\n  font-family: inherit;\n}\n\n/* ── 공통 ── */\n.admin-dp__mono {\n  font-family: var(--admin-font-mono);\n  font-size: 12px;\n}\n\n.admin-dp__spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: adminDpSpin 0.7s linear infinite;\n}\n\n.admin-btn--secondary .admin-dp__spinner {\n  border-color: var(--admin-border);\n  border-top-color: var(--admin-text-secondary);\n}\n\n@keyframes adminDpSpin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── 섹션 로딩/에러/빈 상태 ── */\n.admin-dp__state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 220px;\n  padding: 40px 20px;\n  color: var(--admin-text-muted);\n  font-size: 13px;\n}\n\n.admin-dp__state--error {\n  flex-direction: column;\n  color: var(--admin-text-secondary);\n}\n\n.admin-dp__state-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--admin-border);\n  border-top-color: var(--admin-accent);\n  border-radius: 50%;\n  animation: adminDpSpin 0.7s linear infinite;\n}\n\n.admin-pg__ellipsis {\n  padding: 0 4px;\n  color: var(--admin-text-muted);\n  font-size: 13px;\n}\n\n.admin-dp__source-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  white-space: nowrap;\n}\n\n.admin-dp__source-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.admin-dp__count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-dp__count--new {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-dp__count--upd {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-dp__count--exp {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-dp__count--skip {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n/* ── 탭 1: 개요 ── */\n.admin-dp__overview {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.admin-dp__kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.admin-dp__kpi {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 18px 20px;\n}\n\n.admin-dp__kpi-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--admin-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.admin-dp__kpi-icon--accent {\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent);\n}\n\n.admin-dp__kpi-icon--info {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-dp__kpi-icon--success {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-dp__kpi-icon--error {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-dp__kpi-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.admin-dp__kpi-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__kpi-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n  line-height: 1.2;\n}\n\n.admin-dp__kpi-sub {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__overview-row {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 16px;\n}\n\n.admin-dp__chart-legend {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__source-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 20px;\n}\n\n.admin-dp__source-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--admin-border-light);\n}\n\n.admin-dp__source-row:last-child {\n  border-bottom: none;\n}\n\n.admin-dp__source-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-dp__source-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-dp__source-time {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-family: var(--admin-font-mono);\n}\n\n.admin-dp__source-counts {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-dp__trend-chart {\n  width: 100%;\n  max-width: 360px;\n  display: block;\n  margin: 0 auto;\n}\n\n.admin-dp__trend-bar {\n  fill: var(--admin-accent);\n  opacity: 0.85;\n}\n\n.admin-dp__trend-value {\n  font-size: 10px;\n  font-weight: 600;\n  fill: var(--admin-text-secondary);\n}\n\n.admin-dp__trend-date {\n  font-size: 10px;\n  fill: var(--admin-text-muted);\n}\n\n/* 파이프라인 흐름 */\n.admin-dp__flow {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.admin-dp__flow-step {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 16px 12px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n  text-align: center;\n}\n\n.admin-dp__flow-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n}\n\n.admin-dp__flow-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n.admin-dp__flow-sub {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__flow-branch {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px;\n}\n\n.admin-dp__flow-arrow {\n  display: flex;\n  align-items: center;\n  color: var(--admin-text-dim);\n  flex-shrink: 0;\n}\n\n/* ── 탭 2: 데이터 검수 ── */\n.admin-dp__review {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.admin-dp__filter-card .admin-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n}\n\n.admin-dp__filter-cats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.admin-dp__cat-chip {\n  padding: 5px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: 9999px;\n  background: var(--admin-surface);\n  color: var(--admin-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-dp__cat-chip:hover {\n  border-color: var(--admin-accent);\n  color: var(--admin-accent);\n}\n\n.admin-dp__cat-chip--on {\n  background: var(--admin-accent-bg);\n  border-color: var(--admin-accent);\n  color: var(--admin-accent);\n  font-weight: 600;\n}\n\n.admin-dp__filter-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-dp__filter-select {\n  width: auto;\n  min-width: 120px;\n  padding: 8px 12px;\n  font-size: 12px;\n}\n\n.admin-dp__filter-search {\n  flex: 1;\n  max-width: 280px;\n  margin-left: auto;\n}\n\n.admin-dp__title-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 220px;\n}\n\n.admin-dp__title-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-dp__title-sub {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-family: var(--admin-font-mono);\n}\n\n.admin-dp__cat-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  max-width: 200px;\n}\n\n.admin-dp__cat-tag {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent-hover);\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-dp__amount {\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  white-space: nowrap;\n}\n\n.admin-dp__deadline-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.admin-dp__dday {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__dday--urgent {\n  color: var(--admin-error);\n}\n\n.admin-dp__empty-row td {\n  text-align: center;\n  padding: 48px 16px;\n  color: var(--admin-text-muted);\n  font-size: 13px;\n  cursor: default;\n}\n\n.admin-dp__empty-row:hover {\n  background: transparent !important;\n}\n\n/* ── 탭 3: 동기화 이력 ── */\n.admin-dp__history-table td {\n  white-space: nowrap;\n}\n\n.admin-dp__num--new {\n  color: var(--admin-success);\n  font-weight: 600;\n}\n\n.admin-dp__num--upd {\n  color: var(--admin-info);\n  font-weight: 600;\n}\n\n.admin-dp__run-row--failed {\n  background: var(--admin-error-bg);\n}\n\n.admin-dp__run-log-row td {\n  background: var(--admin-bg);\n  cursor: default;\n}\n\n.admin-dp__run-log {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  padding: 4px 8px;\n}\n\n.admin-dp__run-log-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--admin-error);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  flex-shrink: 0;\n}\n\n.admin-dp__run-log code {\n  font-family: var(--admin-font-mono);\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n/* ── 탭 4: 분류체계 ── */\n.admin-dp__taxonomy {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.admin-dp__cat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.admin-dp__cat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n}\n\n.admin-dp__cat-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.admin-dp__cat-card-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n}\n\n.admin-dp__cat-card-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-accent);\n  background: var(--admin-accent-bg);\n  padding: 2px 8px;\n  border-radius: 9999px;\n}\n\n.admin-dp__cat-card-desc {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__mapping-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.admin-dp__mapping-add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--admin-bg);\n  border: 1px dashed var(--admin-border);\n  border-radius: var(--admin-radius-md);\n}\n\n.admin-dp__mapping-input {\n  flex: 1;\n  padding: 8px 12px;\n  font-size: 12px;\n}\n\n.admin-dp__mapping-arrow {\n  color: var(--admin-text-muted);\n  flex-shrink: 0;\n}\n\n.admin-dp__mapping-row {\n  cursor: default !important;\n}\n\n.admin-dp__mapping-actions {\n  text-align: right;\n}\n\n/* ── 상세 드로어 ── */\n.admin-dp__drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(2px);\n  z-index: 900;\n  animation: adminDpFadeIn 0.15s ease;\n}\n\n@keyframes adminDpFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.admin-dp__drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 760px;\n  max-width: 92vw;\n  background: var(--admin-surface);\n  border-left: 1px solid var(--admin-border);\n  box-shadow: var(--admin-shadow-modal);\n  z-index: 901;\n  display: flex;\n  flex-direction: column;\n  animation: adminDpSlideIn 0.2s ease;\n}\n\n@keyframes adminDpSlideIn {\n  from { transform: translateX(24px); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n.admin-dp__drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-dp__drawer-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.admin-dp__drawer-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.admin-dp__drawer-badges {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-dp__drawer-sourceid {\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n}\n\n.admin-dp__drawer-col {\n  padding: 20px 24px;\n  min-width: 0;\n}\n\n.admin-dp__drawer-col:first-child {\n  border-right: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n}\n\n.admin-dp__drawer-col-title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n  margin: 0 0 14px;\n}\n\n.admin-dp__drawer-col-hint {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__raw-json {\n  margin: 0;\n  padding: 14px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n  font-family: var(--admin-font-mono);\n  font-size: 11.5px;\n  line-height: 1.7;\n  color: var(--admin-text-secondary);\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.admin-dp__norm-list {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n}\n\n.admin-dp__norm-row {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 12px;\n  padding: 9px 0;\n  border-bottom: 1px solid var(--admin-border-light);\n}\n\n.admin-dp__norm-row:last-child {\n  border-bottom: none;\n}\n\n.admin-dp__norm-row dt {\n  font-family: var(--admin-font-mono);\n  font-size: 11.5px;\n  color: var(--admin-text-muted);\n}\n\n.admin-dp__norm-row dd {\n  margin: 0;\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  word-break: break-word;\n}\n\n.admin-dp__edit-form .admin-form-group {\n  margin-bottom: 14px;\n}\n\n.admin-dp__edit-textarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\n.admin-dp__drawer-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 24px;\n  border-top: 1px solid var(--admin-border);\n}\n\n.admin-dp__drawer-footer-left,\n.admin-dp__drawer-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── 반응형 ── */\n@media (max-width: 1280px) {\n  .admin-dp__kpi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .admin-dp__overview-row {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-dp__cat-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 960px) {\n  .admin-dp__flow {\n    flex-direction: column;\n  }\n\n  .admin-dp__flow-arrow {\n    transform: rotate(90deg);\n    justify-content: center;\n  }\n\n  .admin-dp__drawer-body {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-dp__drawer-col:first-child {\n    border-right: none;\n    border-bottom: 1px solid var(--admin-border);\n  }\n\n  .admin-dp__filter-row {\n    flex-wrap: wrap;\n  }\n\n  .admin-dp__filter-search {\n    max-width: none;\n    width: 100%;\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
